// i18n area 'apps' — locale tr-TR (task #171, onda 5): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/apps.tr-TR.meta.json.
import type { enUS } from './apps'

export const trTR: typeof enUS = {

  // Apps wave 1 (Annex R): worker denetimindeki yönetilen podman konteynerleri.
  apps: {
    title: 'Uygulamalar',
    create: 'Uygulama oluştur',
    createTitle: 'Uygulama oluştur',
    editTitle: 'Uygulamayı düzenle',
    name: 'Ad',
    nameHint: 'DNS-1123, scope içinde benzersiz — oluşturmadan sonra değiştirilemez.',
    node: 'Düğüm',
    nodeHint: 'Ona hizmet veren üye düğüm — açık placement (scheduler daha sonra gelecek).',
    image: 'Görüntü',
    editImageHint: 'Yeni bir referans envanter üzerinden yeniden çözümlenir — pin/geri alma hareketi.',
    imagePolicy: 'Policy',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'Digest yalnızca komutla hareket eder.',
    policyTrackingHint: "Bir refresh branch'i taşıdığında otomatik olarak ilerler.",
    archMovePolicy: 'Cross-arch taşıma',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: "App başka bir mimarideki bir node'a taşınırsa ne olur: refuse taşımayı reddeder, reresolve lockfile'ı yeni arch üzerinde branch'ten yeniden çözer — içerik değişir ve yanıt digest değişikliğini adlandırır.",
    network: 'Ağ',
    networkHint: 'Untagged L3 bağlantısı: bir fabric mantıksal ağı (önerilen — ağ geçidi/DNS tek kaynağından), bir overlay ya da çıplak bir host köprüsü (önerilmez).',
    overlayPrefix: 'overlay:',
    fabricPrefix: 'fabric:',
    bridgePrefix: 'host köprüsü:',
    ipAssignment: 'IP ataması',
    ipStatic: 'Statik',
    ipAuto: 'Otomatik (IPAM)',
    ipAssignmentHint_static: 'Adresi şimdi siz verirsiniz.',
    ipAssignmentHint_auto: "IPAM, ağın TVirt'e ayrılmış aralıklarından boş bir adres seçer.",
    bridgeDiscouraged: 'Çıplak host köprüsü — ÖNERİLMEZ: TVirt onun adreslemesi hakkında hiçbir şey bilmez, bu yüzden ağ geçidi ve DNS elle verilmelidir. Önerilen yol bir fabric mantıksal ağıdır.',
    ip: 'IP',
    ipHint: 'Bağlantının alt ağı içinde statik IPv4.',
    ipCidrHint: 'Çıplak köprüde CIDR biçiminde (örn. 192.168.1.10/24) — öneki türetecek bir kaynak yok.',
    gateway: 'Ağ geçidi',
    gatewayManualHint: 'Manuel — çıplak bir köprü hiçbir şey türetmez.',
    dnsServers: 'DNS sunucuları',
    dnsManualHint: 'Manuel, virgülle ayrılmış — en az bir tane.',
    rootKind: 'Root',
    rootEphemeral: 'geçici',
    rootPersistent: 'kalıcı',
    rootEphemeralHint: 'Her yeniden oluşturmada görüntüden yeniden oluşturulur; kümenin geçici depolamasında yaşar.',
    rootEphemeralHintNamed: 'Her yeniden oluşturmada görüntüden yeniden oluşturulur; kümenin geçici depolamasında yaşar ({name}).',
    rootPersistentHint: 'Yeniden başlatmalara dayanır; seçtiğiniz depolamada yaşar.',
    rootStorage: 'Root depolaması',
    editRootStorageHint: 'Root yeni havuzda yeniden oluşturulur — mevcut veriler kendiliğinden TAŞINMAZ.',
    volumes: 'Birimler',
    volumeAdd: 'Birim ekle',
    volumeName: 'Ad',
    volumeMountPath: 'Bağlama yolu',
    volumeKind: 'Tür',
    volumeStorage: 'Depolama',
    devices: 'Aygıtlar',
    deviceClassHint: 'Bir SINIF istenir (gpu-device veya usb-device etiketi), asla belirli bir aygıt: bildirilen düğümde Apps için işaretlenmiş bir aygıt bulunmalıdır. Birden çok App aynı aygıtı kullanabilir — bir konteyner onu paylaşır, ana makineden almaz.',
    deviceSlot: 'Yuva',
    deviceTag: 'Etiket',
    deviceValue: 'Sınıf',
    deviceUnresolved: 'şu anda hiçbir şey çözümlenmiyor',
    noDeviceTags: 'Henüz gpu-device veya usb-device türünde etiket yok: bir tane oluşturup Apps için işaretlenmiş aygıtlara ata.',
    env: 'Ortam',
    envHint: 'Her satıra bir ANAHTAR=değer.',
    secretEnvTitle: 'Gizli değişkenler',
    secretEnvNotice: "Gizli bir değer API'den bir daha asla geri dönmez: kimse onu yeniden okuyamaz, yazan bile. Checkpointte masterpass ile mühürlenmiş olarak yolculuk eder, bu yüzden masterpass olmadan bir geri yükleme onu yeniden yazmayı ister.",
    secretEnvPromote: 'Yukarıda yazılan değişkenlerden birini gizli yapın:',
    secretEnvAdd: 'Gizli değişken ekle',
    secretEnvName: 'Ad',
    secretEnvValue: 'Değer',
    secretEnvKept: 'korunuyor — değiştirmemek için boş bırakın',
    secretEnvWithdrawWarning: "Zaten gizli olan bir değişkeni gizli saymayı bırakmak için ona yeni bir değer yazın: yalnızca işareti kaldırmak, store'dan hiç çıkmayan şeyi OKUMANIN bir yolu olurdu. Değişkeni kaldırmak ise onu siler.",
    secretEnvChip: 'gizli',
    startNow: 'Hemen başlat (aksi halde uygulama durdurulmuş olarak oluşturulur)',
    deletePersistentIntro: 'Bu uygulamanın kalıcı verileri var — onlara ne olacağını seçin:',
    deleteKeepData: 'Verileri koru (dizinler kendi depolamalarında, sahipsiz olarak kalır)',
    deletePurgeData: 'Verileri de sil',
    phase: 'Aşama',
    phase_running: 'Çalışıyor',
    phase_stopped: 'Durduruldu',
    phase_error: 'Hata',
    phase_unknown: 'Bilinmiyor',
    desiredState: 'İstenen',
    wantedRunning: 'çalışıyor',
    wantedStopped: 'durduruldu',
    start: 'Başlat',
    stop: 'Durdur',
    restart: 'Yeniden başlat',
    refreshImage: 'Görüntüyü yenile (yeni @current benimsenir)',
    logs: 'Günlükler',
    logsTitle: 'Günlükler',
    logsEmpty: 'Yakalanan çıktı yok.',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'App çalışmıyor — bir shell canlı bir container ister. Logları her durumda okunabilir.',
    shellConnect: 'Bağlan',
    shellDisconnect: 'Bağlantıyı kes',
    shellExited: 'Oturum {code} çıkış koduyla sona erdi.',
    shellEndedWithoutStatus: 'Oturum bir çıkış durumu olmadan sona erdi: {reason}',
    shellRevoked: "Oturumun ticket'ı artık geçerli değil — süresi doldu ya da onu açan oturum açma işlemi iptal edildi.",
    shellHint: "Siyah alana tıklayıp yazın: tuşlar container'a gider. Ctrl+C ve ok tuşları çalışır; exit shell'i kapatır.",
    shellStatus: {
      connecting: 'Bağlanıyor…',
      connected: 'Bağlı',
      ended: 'Sona erdi'
    },
    deleteRunningError: '{name} uygulamasının istenen durumu çalışıyor — önce durdurun.',

    // Dialog standard (round #156)
    tabs: {
      general: 'Genel',
      image: 'Görüntü',
      network: 'Ağ',
      storage: 'Depolama',
      devices: 'Aygıtlar',
      observed: 'Gözlemlenen'
    },
    attachment: 'Bağlantı',
    runningDigest: 'Çalışan digest',
    lastError: 'Son hata',
    reportObservedAt: 'Son worker raporu',
    desiredStateLock: 'Başlat/Durdur eylemleri tarafından yönetilir — asla doğrudan düzenlenmez.',
    ipEditDisabledHint: 'Yalnızca statik atamayla düzenlenebilir.',
    derivedFromNetworkHint: "Ağın tek kaynağından türetilir — manuel yalnızca statik IP'li çıplak köprüde.",
    ephemeralUnset: 'yapılandırılmadı',
    ephemeralMissing: 'Uygulamaların geçici depolaması yapılandırılmadı — geçici parçası (root veya birim) olan bir uygulama oluşturmak, siz onu ayarlayana kadar reddedilir.',
    ephemeralCurrent: 'Uygulamaların geçici depolaması: {name}',
    ephemeralMissingCreate: "Bu uygulamanın geçici parçaları var ama kümenin Uygulama geçici depolaması ayarlanmamış — oluşturma reddedilecek. Önce Uygulamalar sayfasındaki banner'dan ayarlayın.",
    setEphemeral: 'Geçici depolamayı ayarla',
    changeEphemeral: 'Geçici depolamayı değiştir',
    setEphemeralTitle: 'Uygulamaların geçici depolamasını ayarla',
    changeEphemeralTitle: 'Uygulamaların geçici depolamasını değiştir',
    ephemeralStorageHint: "Küme genelinde VARSAYILAN: uygulama kendi override'ını bildirmedikçe, her uygulamanın geçici rootları ile geçici birimlerinin yaşadığı dir benzeri havuz. Değişiklik anında etkili olmaz ve hiçbir şeyi yeniden başlatmaz: her uygulamanın bir sonraki başlatılışında geçerli olur — geçici veriler taşınmaz.",
    ephemeralPool: 'Depolama havuzu',
    ephemeralOverride: 'Geçici depolama (uygulama başına override)',
    ephemeralOverrideInherit: 'Küme varsayılanını devral',
    ephemeralOverrideInheritNamed: 'Küme varsayılanını devral ({name})',
    ephemeralOverrideHint: 'Geçici root ve birimler için uygulama başına havuz — küme varsayılanını devralmak için boş bırakın. Değiştirmek anında etkili olmaz ve hiçbir şeyi yeniden başlatmaz: bir sonraki başlatmada geçerli olur (geçici veriler yeni havuzda boş olarak yeniden doğar) ve app.ephemeralStorage.set iznini gerektirir.',
    ephemeralOverrideTag: 'override',

    imageAnyBranch: 'Tüm dallar',
    imageBranchHint: 'İmajları bu dalın adlandırdıklarıyla sınırlar; dal seçilmezse deponun tüm imajları görünür.',
    imageDigestHint: 'İçerik: kökenini ve mimarisini taşıyan digest tablosundan seçilir. Aynı dal her mimari için bir tane sunar ve bunlar birbirinin yerine geçmez.',
    imageLockfile: 'Çözümlenmiş başvuru',
    imageNoImages: 'Bu depo için önbellekte imaj yok — OCI imajlarından birini indir.',
    imageHeadNotCached: 'önbellekte değil — başlangıçta indirilir',
    imageNoRegistries: 'Kayıtlı depo yok: imaj seçebilmek için bir tane kaydet.',
    imageChosenHint: 'İmaj, düzenleme penceresindeki kademeli seçimle belirlenir: başvuru asla elle yazılmaz.',
    registerRepositoryHint: 'Kaydetmek hiçbir şey indirmez: bir depoyu izlenebilir kılar, böylece imaj bu pencereden çıkmadan seçilebilir.',
    registerRepositoryBranchHint: 'İsteğe bağlı: izlenecek ilk dal (örn. latest).',
    registerRepositoryElsewhere: 'Aradığın depo kayıtlı değil: kayıt, OCI imajları bölümünde, izni olan biri tarafından yapılır.'
  },

  // Template CT (round K2 #63): MATERYALLEŞTİRİLMİŞ CT nesneleri.
  cts: {
    createAction: 'CT oluştur',
    createTitle: 'Şablondan konteyner oluştur',
    createError: 'Konteyner oluşturulamadı',
    template: 'CT şablonu',
    noTemplates: 'CT şablonu yok — CT şablonları bölümünden bir tane içe aktarın',
    resources: 'Kaynaklar',
    node: 'Düğüm',
    phase: {
      defined: 'Hiç açılmadı',
      materializing: 'Materyalleştiriliyor',
      ready: 'Hazır',
      starting: 'Başlatılıyor',
      running: 'Çalışıyor',
      stopping: 'Kapatılıyor',
      stopped: 'Kapatıldı',
      deleting: 'Siliniyor',
      error: 'Hata durumunda'
    },
    actions: {
      start: 'Başlat',
      stop: 'Kapat',
      restart: 'Yeniden başlat',
      markTemplate: 'CT şablonuna yükselt',
      error: 'Eylem reddedildi'
    },
    markTemplate: {
      confirmTitle: "'{name}' CT şablonuna yükseltilsin mi?",
      confirmBody: "Konteyner bu listeden ayrılır ve CT şablonlarına katılır; hemen yeni CT'ler üretmeye hazır olur. Metadata düzenlenebilir kalır ve onu istediğiniz an yeniden CT'ye döndürebilirsiniz.",
      confirm: 'Yükselt',
      moved: "'{name}' artık bir CT şablonu — onu CT şablonları altında bulabilirsiniz."
    },
    stopCause: {
      api: 'TVirt üzerinden kapatıldı',
      'ct-exit': 'Konteyner kendi kendine çıktı',
      'host-reboot': 'Düğümün yeniden başlatılmasıyla öldü',
      'start-failed': 'Başlatma başarısız oldu — görev hatası neyin eksik olduğunu ve nasıl düzeltileceğini söyler'
    },

    console: 'Konsol',
    consoleUnavailable: 'Konteyner çalışmıyor — konsol için canlı bir konteyner gerekir. Günlükleri ise her durumda okunabilir.',
    consoleNoTemplate: 'Şablon hiç çalışmaz, dolayısıyla konsolu da yoktur: ondan bir CT oluşturun ve onunkini açın.',
    consoleConnect: 'Bağlan',
    consoleDisconnect: 'Bağlantıyı kes',
    consoleReconnect: 'Yeniden bağlan',
    consoleTakenBy: 'Bu konsolu başka bir operatör devraldı ({user}). Konteyner başına bir konsol: yeniden bağlanmak onu geri alır.',
    consoleHint: 'Siyah alana tıklayıp yazın: tuşlar konteynere ulaşır. Ctrl+C ve ok tuşları çalışır.',
    consoleEndpointDown: 'Konsolun erişim noktası, container\'ı sunan node üzerinde açılamıyor: {cause}',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Container çalışmıyor — bir shell için canlı bir container gerekir. Logları her durumda okunabilir.',
    shellNoTemplate: 'Bir template hiç çalışmaz, dolayısıyla shell\'i yoktur: ondan bir CT oluşturun ve onunkini açın.',
    shellConnect: 'Bağlan',
    shellDisconnect: 'Bağlantıyı kes',
    shellExited: 'Oturum {code} çıkış koduyla sona erdi.',
    shellEndedWithoutStatus: 'Oturum bir çıkış durumu olmadan sona erdi: {reason}',
    shellRevoked: "Oturumun ticket'ı artık geçerli değil — süresi doldu ya da onu açan oturum açma işlemi iptal edildi.",
    shellHint: "Siyah alana tıklayıp yazın: tuşlar container'a gider. Ctrl+C ve ok tuşları çalışır; exit shell'i kapatır.",
    shellStatus: {
      connecting: 'Bağlanıyor…',
      connected: 'Bağlı',
      ended: 'Sona erdi'
    },
    rootPassword: 'Root parolası',
    rootPasswordHint: 'Kopyalanan rootfs\'e bir kez yazılır (hash olarak, bir daha gösterilmez). Dağıtımların image\'larında root parolası yoktur: parola olmadan shell tek giriştir.',
    sshKeys: 'Root\'un açık SSH anahtarları',
    sshKeysHint: 'Her satıra bir açık OpenSSH anahtarı, root/.ssh/authorized_keys içine.',
    consoleStatus: {
      connecting: 'Bağlanılıyor…',
      connected: 'Bağlandı',
      reconnecting: 'Yeniden bağlanılıyor…'
    },
    logs: 'Günlükler',
    logsTitle: 'Günlükler',
    logsEmpty: 'Yakalanan çıktı yok.',
    logsSource: 'Hangi günlük',
    logsSourceConsole: 'Konteynerin init konsolu — içindeki servisin neden başlamadığı',
    logsSourceSupervisor: 'liblxc süpervizörü — konteynerin neden hiç çalışmaya bile geçemediği',
    logsNeverStarted: 'Hiç başlatılmadı, bu yüzden henüz kaydedilmiş bir şey yok — başlatın, başlatma başarısız olsa bile günlükler orada olacak.',
    logsNoTemplate: 'Şablon hiç çalışmaz, dolayısıyla hiçbir zaman bir şey kaydetmedi.',
    logsError: 'Günlükler yakalanamadı',

    // Dialog standard (round #156)
    tabs: {
      general: 'Genel',
      hardware: 'Donanım',
      network: 'Ağ',
      provenance: 'Köken'
    },
    templateFlag: 'CT şablonu',
    templateLock: "Yalnızca Yükselt / CT'ye geri döndür eylemleriyle değişir — asla doğrudan düzenlemeyle değil.",
    sourceLock: 'Köken, doğumda kaydedilir — asla yeniden yazılmaz; ölü bir kaynak geriye çıplak referansı bırakır.',
    storageLock: "Oluşturma sırasında sabitlenir — rootfs'in taşınması gelecekteki bir round.",
    startedAt: 'Başlatıldı',
    lastStop: 'Son kapatma',
    editNicsTitle: 'Ağları düzenle',
    nicDisconnected: 'bağlı değil'
  },
  ctTemplates: {
    title: 'CT Şablonları',
    importAction: 'Katalogdan içe aktar',
    importTitle: 'Katalogdan CT şablonu içe aktar',
    importSubmit: 'İçe aktar',
    importError: 'İçe aktarma reddedildi',
    importHint: "Materyalleştirme, rootfs'i seçilen depolamaya kopyalar — katalog dosyası olduğu gibi kalır. Yeni dosyalar eklemek için önce onları bir kataloğun içine yükleyin.",
    sourceFile: 'CT şablonu dosyası',
    sourceFileHint: 'Seçilen kataloğun ct-rootfs dosyaları, yalnızca hazır olanlar',
    noFiles: 'Bu katalogda hazır ct-rootfs dosyası yok — katalog sayfasından bir tane yükleyin',
    source: 'Kaynak dosya',
    rootfsStorage: 'Rootfs depolaması',
    rootfsStorageHint: "Ayıklanan rootfs ağacının yaşadığı yer — ayıklanan boyut artı yaklaşık 1 GiB pay için yeterli boş alana sahip, dosya sistemli bir depolama (aksi halde içe aktarma başarısız olur).",
    resources: 'Kaynaklar',
    cores: 'vCPU',
    memoryMiB: 'Bellek (MiB)',
    cpuLimit: 'CPU limiti',
    cpuLimitHint: 'Host çekirdeği eşdeğeri (örn. 1.5); boş = sınırsız',
    cpuUncapped: 'sınırsız',
    cpuWeight: 'CPU ağırlığı',
    hostname: 'Hostname',
    hostnameHint: "Boş = CT'nin kendi adı",
    nameservers: "DNS nameserver'ları",
    dnsHint: 'Virgülle ayrılmış; boş = hostunkileri devralır',
    searchDomains: 'DNS arama etki alanları',
    dnsInherited: 'Hosttan devralındı',
    networks: 'Ağlar',
    nicSlot: 'NIC yuvası',
    phase: {
      materializing: 'Materyalleştiriliyor',
      ready: 'Hazır',
      deleting: 'Siliniyor',
      error: 'Hata'
    },
    exportAction: 'Kataloğa dışa aktar',
    exportTitle: 'Kataloğa dışa aktar',
    exportSubmit: 'Dışa aktar',
    exportError: 'Dışa aktarma reddedildi',
    exportHint: 'Materyalleştirilmiş rootfs, seçilen katalogda YENİ bir ct-rootfs dosyası olarak paketlenir — şablon olduğu gibi kalır.',
    exportName: 'Dosya adı',
    exportNameHint: 'Boş = <template>-export-<n>',
    markCt: {
      action: "CT'ye geri döndür",
      confirmTitle: "'{name}' yeniden CT'ye döndürülsün mü?",
      confirmBody: 'Şablon bu listeden ayrılır ve CT listesine geri döner; yeniden başlatılabilir olur. Onu tekrar yükseltene kadar ondan yeni CT oluşturulamaz.',
      confirm: "CT'ye geri döndür",
      moved: "'{name}' yeniden sıradan bir CT — onu CT listesinde bulabilirsiniz."
    }
  },

  // OCI wave 1 (Annex Q — tag-branch modeli): bir OCI etiketi bir branch'tir
  // (hareketli işaretçi), digest ise commit'tir.
  oci: {
    registriesTitle: "OCI registry'leri",
    imagesTitle: 'OCI görüntüleri',
    provider: 'Provider',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Genel',
    providerImmutableHint: 'Provider oluşturmadan sonra değiştirilemez — farklı bir provider yeni bir registry demektir.',
    url: 'URL',
    urlHintPreset: "Provider tarafından önceden doldurulur — yalnızca mirror'lar için üzerine yazın.",
    urlHintRequired: "Genel registry'ler için zorunlu: https:// taban URL'si.",
    urlHintEcr: "Zorunlu: ECR endpoint'leri account ve bölge başınadır — preset yoktur.",
    credential: 'Kimlik bilgisi',
    credentialNone: 'Anonim erişim',
    credentialHint: "Kullanıcı adı ve parola içeren bir keystore girdisi; worker'lar onu kullanım anında çözer — asla düğüm başına auth dosyaları değil.",
    nameHint: 'Host benzeri ad (docker.io, registry.intra); scope başına benzersiz, değiştirilemez',
    addRegistry: 'Registry ekle',
    addRegistryTitle: "OCI registry'si ekle",
    verify: 'Doğrula',
    verifyState: 'Doğrulama',
    verified: 'Doğrulandı',
    verifyFailed: 'Başarısız',
    neverVerified: 'Hiç doğrulanmadı',
    registryInUseError: "'{name}' üzerinde hâlâ kayıtlı depolar var — önce onları silin.",
    repositories: 'Depolar',
    repositoriesHint: "Kaydetmek branch'leri (OCI etiketleri) gözlemler — hiçbir şey indirmez. Refresh, gözlemlenen her branch'i çözümler ve reflog'u korur.",
    noRepositories: "Bu registry'de kayıtlı depo yok.",
    registerRepository: 'Depo kaydet',
    repoPath: 'Yol',
    repoPathHint: "Deponun registry üzerindeki yolu, örn. 'example' veya 'library/nginx'",
    branches: "Branch'ler",
    branchesHint: "Gözlemlenen branch'ler (OCI etiketleri), virgülle ayrılmış — örn. 1.1.0, 1.1.1",
    branch: 'Branch',
    branchPullHint: "ŞİMDİ çözümlenir: pull, branch'in bugün işaret ettiği digest'i indirir.",
    refresh: 'Yenile',
    deleteRepository: 'Depoyu sil',
    reflogCount: '{n} önceki',
    noResolutions: 'Hiç yenilenmedi — gözlemlenen çözümleme yok.',
    refreshFailed: 'Son yenileme başarısız oldu ({when})',
    loadError: 'Depolar yüklenemedi.',
    reference: 'Referans',
    digest: 'Digest',
    digestHint: 'sha256:… — birebir görüntü, branch yok (detached)',
    size: 'Boyut',
    nodes: 'Düğümler',
    detached: 'detached',
    detachedHint: "Digest'e göre indirildi, branch yok — drift denetimi uygulanmaz.",
    pulledAt: 'İndirildi',
    pull: 'Pull',
    pullTitle: "Görüntü pull'u",
    pullHint: "Pre-warming, asla bir ön koşul değildir: branch'e göre pull ŞİMDİ çözümler ve O digest'i indirir; digest'e göre pull ise detached'dir.",
    pullError: 'Pull reddedildi',
    pullMode: 'Pull yöntemi',
    pullModeBranch: 'Branch (şimdi çözümle)',
    pullModeDigest: 'Digest (detached)',
    pullModeBranchHint: 'Dürüst varsayılan: apt install gibi, daha sonra yeniden çalıştırıldığında farklı bir görüntü verebilir.',
    pullModeDigestHint: 'Birebir digest — yeniden üretilebilirlik ve geri alma; drift denetiminden vazgeçer.',

    // İki düğmeli içe aktarma deseni (#88, ratifica 2026-07-30 sera)
    importFromRegistry: "Registry'den içe aktar",
    importFromCatalog: 'Katalogdan içe aktar',
    importCatalogTitle: 'Katalogdan OCI görüntüsü içe aktar',
    importCatalogHint: "Air-gapped yol: hazır bir oci-image arşivi (tar/tar.gz — docker-archive veya oci-archive), catalog/<katalog>/<dosya>@<digest> referansıyla görüntü store'una materyalleştirilir; uygulamalar onu diğer tüm görüntüler gibi tüketir. Arşivler kataloglara yüklenir — bu bölüm yalnızca içe aktarır.",
    importCatalogFile: 'Arşiv',
    importCatalogFileHint: 'Seçilen kataloğun hazır oci-image dosyaları.',
    importCatalogNoFiles: 'Bu katalogda hazır oci-image arşivi yok — katalog ayrıntısından bir tane yükleyin.',
    importCatalogError: 'İçe aktarma reddedildi',
    registry: 'Registry',
    repository: 'Depo',
    cacheMissing: "Kümenin OCI önbelleği yapılandırılmadı — bir depolama havuzu ayarlayana kadar pull'lar reddedilir.",
    setCache: 'Önbelleği ayarla',
    setCacheTitle: 'OCI önbelleğini yapılandır',
    setCacheHint: "İndirilen görüntü blob'larını barındıran küme düzeyindeki VARSAYILAN havuz — bir scope kendi havuzuyla override yapabilir (Scope sayfası). Değiştirmek anında etkili olmaz ve hiçbir şeyi yeniden başlatmaz, blob'ları da taşımaz: bir sonraki başlatmada/kullanımda lazy olarak yeniden belirirler.",
    cachePool: 'Depolama havuzu',
    changeCache: 'Önbelleği değiştir',
    changeCacheTitle: 'OCI önbellek havuzunu değiştir',
    cacheCurrent: 'Kümenin OCI önbelleği (varsayılan): {name}',
    sectionOverview: 'Genel bakış',
    sectionRepositories: 'Depolar',
    sectionExplore: 'Keşfet',
    exploreHint: "Registry üzerinde canlı uzak arama — Docker Hub'da tam (açıklama, indirme, yıldız), diğer provider'larda best-effort. Tam açıklamasını okumak ve uzak etiketlerine göz atmak için bir sonuç seçin; bir etiketten, referansı bir TVirt deposuna ekleyebilirsiniz.",
    exploreSearch: 'Ara',
    exploreUnsupported: 'Bu provider aramayı desteklemiyor.',
    exploreNoResult: 'Eşleşen depo yok.',
    exploreNoTags: 'Bu depoda eşleşen etiket yok.',
    exploreOfficial: 'Resmî',
    explorePulls: 'İndirme',
    exploreStars: 'Yıldız',
    exploreUpdated: '{when} güncellendi',
    exploreLoadMore: 'Daha fazla yükle',
    exploreSelectHint: 'Bir sonuç seçin: tam açıklama ve uzak etiketler burada yüklenir.',
    exploreNoDescription: "Bu provider'dan kullanılabilir bir açıklama yok.",
    exploreTagsTitle: 'Uzak etiketler',
    exploreTagFilter: 'Etiket ara',
    exploreAddToRepo: 'Depoya ekle',
    exploreAdded: '{path}:{tag} artık izleniyor — Depolar bölümüne bakın.',
    addBranch: 'Branch ekle',
    purgeRequiredTitle: "'{name}' ve görüntüleri silinsin mi?",
    purgeRequiredBody: "Bu depoyu hiçbir uygulama tüketmiyor, ama hâlâ indirilmiş görüntüler var: depoyu silmek onların kayıtlarını da kaldırır ve önbellekteki blob'lar çöp toplayıcıya gider.",
    purgeConfirm: 'Görüntüleri de sil',
    providerSelectHint: "Registry türünü seçin: kart, preset'i ve kullanımı anlatır.",
    providerDesc: {
      dockerhub: "Herkese açık Docker registry'si: önceden doldurulmuş URL, açıklamalı ve sayaçlı tam arama.",
      ghcr: 'GitHub Container Registry: önceden doldurulmuş URL; accountlar personal access token kullanır.',
      ecr: "Amazon Elastic Container Registry: account ve bölge başına endpoint'ler — URL'nin verilmesi gerekir.",
      quay: "Red Hat Quay registry'si: önceden doldurulmuş URL.",
      generic: "Self-hosted registry (Harbor, registry:2, …): https:// URL'si zorunludur."
    },

    // Dialog standard (round #156)
    layerCount: 'Layer',
    verifiedAt: 'Son doğrulama',
    verifyOk: 'Sonuç',
    verifyMessage: 'Doğrulama mesajı',

    // #348/R39 modeli: imaj digest’in TA KENDİSİDİR — içeriktir — registry, depo ve dal ise ona ulaşan ADLARDIR.
    head: 'Head',
    heads: 'Mimariye göre başlar',
    listDigest: 'Listenin digest’i',
    neverResolved: 'Hiç çözümlenmedi',
    totalSize: 'Toplam boyut',
    reflogTitle: 'Çözümleme geçmişi',
    usedBy: 'Kullanan',
    usageLockfile: 'lockfile',
    usageRunning: 'çalışıyor',
    evictable: 'çıkarılabilir',
    evict: 'Önbellekten çıkar',
    evictHeadTitle: '{digest} önbellekten çıkarılsın mı?',
    evictHeadBody: 'En az bir toplayıcının geçerli çözümlemesi: onu çıkarmak meşrudur — bu yalnızca önbellek, uzak branch onu hâlâ sunuyor — ama asla yanlışlıkla olmamalı. Blob TEKtir: çıkarma, onu paylaşan tüm toplayıcıları boşaltır.',
    evictConfirm: 'Yine de çıkar',

    arch: 'Mimari',
    names: 'Adlar',
    noNames: 'adsız',
    views: 'Görünümler',
    lastView: 'son görünüm',
    evictLastViewTitle: '{digest} için son başvuru kaldırılsın mı?',
    evictLastViewBody: 'Bu, bu içerik üzerindeki son görünümdür: kaldırıldığında imaj TVirt üzerinde var olmayı bırakır ve baytlar ({size}) serbest kalır. Modelin docker image rm’sidir — bir yan etki değil, işlemin ta kendisi.',
    branchesTabHint: 'Bu deponun izlenen dalları: her biri için bugünkü başlar — mimari başına bir tane — yenilemelerin kronolojisi ve adlandırdığı imajlardan kaçının önbellekte olduğu. Yenileme, deponun «git fetch»’idir: tüm dallarını tek seferde çözer.',
    noBranches: 'Bu depoda izlenen dal yok.',
    stopObserving: 'Dalı izlemeyi bırak',
    pullBranch: 'Branch\'in başını önbelleğe indir (refresh çözümler, bu indirir)',
    pullDigest: 'Bu digest\'i önbelleğe indir',
    imageCount: 'İmajlar',
    deleteBranchPurgeTitle: '{name} imajları adsız bırakılsın mı?',
    deleteBranchPurgeBody: 'Hiçbir uygulama bu dalı adlandırmıyor, ancak bazı imajlara yalnızca onun üzerinden ulaşılıyor: silindiğinde önbellekte adsız kalırlar, deponun imajları arasında listelenir ve elle kaldırılabilirler.',
    deleteBranchPurgeConfirm: 'Sil ve imajları adsız bırak',
    imagesTabHint: 'Bu deponun imajları — içerikler, yani digest’ler — dal seçmeden de görünür. Bir imaj küme genelinde tektir: ona ulaşan adlar birden fazla olabilir.',
    noImages: 'Bu deponun hiçbir imajı önbellekte somutlaştırılmamış.',
    deleteRepositoryTitle: '{name} silinsin mi?',
    deleteRepositoryBody: 'Depo ve dalları kronolojileriyle birlikte kaybolur. İmajlar önbellekte kalır: yalnızca bu adı yitirirler. Bir uygulamanın adlandırdığı depo silinemez.',
    provenanceCatalog: 'katalog',
    refreshedAt: 'Yenilendi',
    neverRefreshed: 'Hiç yenilenmedi',
    sectionBranches: 'Dallar',
    sectionImages: 'İmajlar',
    repositoriesGovernedElsewhere: 'Burada depolara yalnızca bakılır: kaydetmek, yenilemek, dallarını izlemek ve imajlarını kaldırmak OCI imajları bölümünde yapılır.',
    gotoImages: 'OCI imajlarına git'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Pod’lar',
    containers: 'Konteynerler',
    instances: 'Örnekler',
    instancesTooltip: '{running} çalışıyor, {error} hatalı',
    placement: 'Yerleşim',
    spread: 'dağılım',
    ha: 'HA',
    templateRevision: 'revizyon',
    deleting: 'Siliniyor',
    empty: 'Pod yok — bir uygulama (tek konteyner) ya da CLI’dan bir pod oluşturun (create-pod).',
    openInstances: 'Örnekleri aç',
    rollingRestart: 'Aşamalı yeniden başlatma',
    scale: 'Ölçekle',
    scaleTitle: '{name} ölçekle',
    scaleHint: 'Örnek sayısı (0–64): yukarı en düşük boş sıra numarası doldurulur, aşağı en yüksek geri çekilir ve kalıcı verileri korunur.',
    scaleError: 'Ölçekleme başarısız',
    replicas: 'Replikalar',
    deleteRunningError: '{name} çalışıyor — önce durdurun.',
    deleteInstancesIntro: '{count} örneğin tümü kaldırılacak.',
    stateRunning: 'Çalışıyor',
    stateStopped: 'Durduruldu',
    editor: {
      createTitle: 'Pod oluştur',
      create: 'Pod oluştur',
      editTitle: 'Pod\'u düzenle',
      nameHint: 'DNS-1123, en fazla 58 karakter — örnekler <ad>-<dizin> olarak adlandırılır; oluşturulduktan sonra değiştirilemez.',
      restartPolicy: 'Yeniden başlatma politikası',
      restartPolicyHint_always: 'Düğüm, çıkan her konteyneri üstel geri çekilmeyle (10 s → 5 dk) yeniden başlatır.',
      restartPolicyHint_onFailure: 'Yalnızca sıfır dışı kodla çıkan konteyner yeniden başlatılır; çıkış 0 dinlenir.',
      restartPolicyHint_never: 'Çıkan konteyner olduğu gibi bırakılır — örnek succeeded veya failed ile biter.',
      grace: 'Tolerans (s)',
      graceHint: 'Bir durdurmanın SIGTERM → SIGKILL sınırı.',
      hostname: 'Ana bilgisayar adı',
      hostnameHint: 'Boş = örneğin adı.',
      hostnameDefault: 'örneğin adı',
      sharePid: 'Konteynerler arasında PID ad alanını paylaş',
      containersIntro: 'Init konteynerleri, konteynerler başlamadan önce sırayla sonuna kadar çalışır; konteynerler örneğin ağını paylaşır (tek IP, aralarında localhost).',
      initContainers: 'Init konteynerleri',
      initAdd: 'Init konteyneri ekle',
      initHint: 'Her biri 0 ile çıkmalı; bir hata örneği hataya düşürür ve düğüm geri çekilmeyle yeniden dener.',
      containerAdd: 'Konteyner ekle',
      atLeastOne: 'Bir Pod\'un en az bir konteynere ihtiyacı var.',
      duplicateNames: 'Konteyner adları Pod içinde benzersiz olmalı (init konteynerleri dahil).',
      containerName: 'Konteyner adı',
      containerInvalid: 'Bu konteyner eksik: ad (DNS-1123), imaj, bildirilen birimlere bağlamalar, sayısal sınırlar ve sonda.',
      command: 'Komut',
      commandHint: 'İmajın entrypoint\'ini geçersiz kılar — satır başına bir argüman, asla kabuk dizesi değil.',
      args: 'Argümanlar',
      argsHint: 'Satır başına bir tane (boşsa imajın CMD\'si).',
      mounts: 'Bağlamalar',
      mountAdd: 'Bağlama ekle',
      mountNoVolumes: 'Önce Depolama sekmesinde bir birim bildirin.',
      readOnly: 'salt okunur',
      resources: 'Sınırlar',
      cpus: 'CPU',
      cpusHint: 'podman --cpus (örn. 1.5)',
      memory: 'Bellek (MiB)',
      memoryHint: 'podman --memory',
      health: 'Canlılık sondası',
      healthCmd: 'Sonda komutu',
      healthCmdHint: 'Her denetim tıkında düğüm tarafından konteyner içinde çalıştırılır — satır başına bir argüman; çıkış 0 = sağlıklı.',
      healthTimeout: 'Zaman aşımı (s)',
      healthRetries: 'Denemeler',
      healthRetriesHint: 'Düğüm konteyneri yeniden başlatmadan önceki ardışık hatalar.',
      ips: 'Statik adresler',
      ipsHint: 'Örnek başına bir tane, sıra numarasına göre — listenin ötesinde ölçekleme reddedilir.',
      instance: 'örnek',
      volumesHint: 'Birimler Pod\'undur; bağlama yolu her konteynerindir (Konteynerler sekmesi).',
      spread: 'Dağılım',
      spreadHint_preferred: 'Mümkünse örnekler farklı düğümlerde.',
      spreadHint_required: 'Örnekler farklı düğümlerde, yoksa ölçekleme reddeder.',
      spreadHint_none: 'Yalnızca karar verici.',
      ha: 'Yüksek erişilebilirlik (opt-in)',
      haHint: "Her kalıcı parça paylaşımlı depolamada; düğüm ölürse HA decider örnekleri başka bir üyede yeniden oluşturur (HA VM'lerdeki gibi otomatik failover).",
      yes: 'evet',
      no: 'hayır'
    },
    detail: {
      container: 'Konteyner',
      actions: 'Eylemler',
      ready: 'Hazır',
      notReady: 'Hazır değil',
      restarts: 'Yeniden başlatmalar',
      lastRestartAt: 'Son yeniden başlatma:',
      backoffUntil: 'Yeniden deneme:',
      stateAbsent: 'yok',
      stateRunning: 'çalışıyor',
      stateTerminated: 'sonlandı',
      stateWaiting: 'bekliyor',
      init: 'init',
      noInstances: 'Örnek yok (replika 0).',
      ha: 'HA',
      haHint: 'Otomatik failover: düğüm ölürse HA decider örneği başka bir üyede yeniden oluşturur (her kalıcı parça paylaşımlı depolamada).',
      authority: 'Authority (düğüm)',
      homeless: 'authority yok',
      homelessHint: "Checkpoint'ten geri yükleme authority'yi dışarıda bırakır (#380): Pod'u ölçeklendirene kadar (aynı replika sayısına bile) hiçbir düğüm ona hizmet vermez.",
      restartContainer: 'Yalnızca bu konteyneri yeniden başlat (pod ayakta kalır)',
      divergingHint: 'Bu örneğin istenen durumu Pod\'un varsayılanından farklı (PD-P19).',
      revisionLag: '{current} üzerinden {applied} revizyonu uygulandı',
      updatedInstances: '{updated}/{desired} örnek bu revizyonda'
    }
  }
}
